$(window).load(function() {
  $('body').removeClass('preload');
});



// WEBPACK FOOTER //
// ./scripts/preLoad.js